import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Building2, UserRound } from "lucide-react";

export default function Login() {
  return (
    <div className="min-h-screen bg-bone pt-14 md:pt-16" data-testid="login-choice-page">
      <section className="mx-auto flex min-h-[calc(100svh-4rem)] max-w-5xl items-center px-6 py-16 md:px-10">
        <div className="w-full">
          <Link to="/" className="inline-flex items-center gap-2 text-xs text-mocha transition-colors hover:text-espresso" data-testid="login-choice-back">
            <ArrowLeft size={14} strokeWidth={1.5} /> Back to FYLLR
          </Link>
          <p className="mt-12 text-[10px] uppercase tracking-[0.3em] text-mocha" data-testid="login-choice-eyebrow">Sign in</p>
          <h1 className="mt-4 max-w-2xl font-serif text-5xl leading-[0.92] text-ink md:text-7xl" data-testid="login-choice-heading">
            Your FYLLR, <em className="text-espresso">your way.</em>
          </h1>
          <div className="mt-12 grid gap-px overflow-hidden border border-sand bg-sand md:grid-cols-2" data-testid="login-choice-options">
            <Link to="/join?mode=signin" className="group bg-bone p-7 transition-colors hover:bg-sand/35 md:p-9" data-testid="login-client-option">
              <UserRound size={22} strokeWidth={1.25} className="text-espresso" />
              <h2 className="mt-8 font-serif text-3xl text-ink">Client sign in</h2>
              <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-ink/60">Access your FYLLR account and bookings.</p>
              <span className="mt-8 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-espresso">Sign in <ArrowRight size={14} strokeWidth={1.5} /></span>
            </Link>
            <Link to="/salon/login" className="group bg-espresso p-7 text-bone transition-colors hover:bg-ink md:p-9" data-testid="login-salon-option">
              <Building2 size={22} strokeWidth={1.25} className="text-bone" />
              <h2 className="mt-8 font-serif text-3xl">Salon partner sign in</h2>
              <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-bone/65">Manage openings, sessions and your partner profile.</p>
              <span className="mt-8 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-bone">Partner sign in <ArrowRight size={14} strokeWidth={1.5} /></span>
            </Link>
          </div>
          <p className="mt-8 text-sm text-ink/60" data-testid="login-new-client-signup">
            New to FYLLR? <Link to="/join" className="text-espresso underline underline-offset-4 transition-colors hover:text-ink">Sign up free</Link>
          </p>
        </div>
      </section>
    </div>
  );
}